import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { MobileBottomNav } from '@/components/primitives/MobileBottomNav';

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <TopBar />
      <div className="flex flex-1">
        <Sidebar />
        {/* min-w-0 + overflow-x-hidden on the flex item so wide children
            (scrollable MUI Tabs in /forecast, wide tables, embedded maps)
            don't inflate the flex row beyond viewport width on mobile.
            Without min-w-0 the flex item defaults to min-width:auto, which
            stretches to the intrinsic content width and forces the whole
            page wider than the screen. */}
        <main className="min-w-0 flex-1 overflow-x-hidden pb-24 md:pb-6">
          <Outlet />
        </main>
      </div>
      <MobileBottomNav />
      <Toaster />
    </div>
  );
}

export default AppShell;
